import PropTypes from 'prop-types';
import React from 'react';
import CustomColorPickerDialog from './CustomColorPickerDialog.js';
import 'classnames';
import 'wix-rich-content-ui-components';
import '../../style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DefaultColorPicker = (_a) => {
  var _b = _a, {
    color,
    onCustomColorPicked,
    onCustomColorCancel,
    onCustomColorUpdate
  } = _b, props = __objRest(_b, [
    "color",
    "onCustomColorPicked",
    "onCustomColorCancel",
    "onCustomColorUpdate"
  ]);
  return /* @__PURE__ */ React.createElement(
    CustomColorPickerDialog,
    __spreadValues({
      color,
      onChange: onCustomColorPicked,
      onUpdate: onCustomColorUpdate,
      onCancel: onCustomColorCancel
    }, props)
  );
};
DefaultColorPicker.propTypes = {
  color: PropTypes.string.isRequired,
  onCustomColorPicked: PropTypes.func,
  onCustomColorCancel: PropTypes.func,
  onCustomColorUpdate: PropTypes.func,
  t: PropTypes.func,
  isMobile: PropTypes.bool
};

export { DefaultColorPicker as default };
//# sourceMappingURL=DefaultColorPicker.js.map
